




































































































































import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import Project from '@/domain/project/project.entity';
import WorkItemSummary from '@/domain/work-item/work-item-summary.entity';
import ButtonComponent from '@/shared/button/button.component.vue';
import OverlayLoader from '@/shared/overlay-loader/overlay-loader.component.vue';
import DropdownComponent from '@/shared/dropdown/dropdown.component.vue';
import snackBarService from '@/shared/snackbar/snackbar.service';
import WorkItemService from '@/domain/work-item/work-item.service';

@Component({
  components: {
    ButtonComponent,
    OverlayLoader,
    DropdownComponent,
  },
})
export default class WorkItemModalExport extends Vue {
  @Prop() dialog!: boolean;

  @Prop() selectedWorkItens!: WorkItemSummary[];

  @Prop() project!: Project;

  reprocessing: boolean = false;

  searchInput: string = '';

  searchOption: string = 'number';

  options: any[] = [
    { label: 'number', value: 'number' },
    { label: 'title', value: 'title' },
  ];

  get optionsTranslated() {
    return this.options.map(option => ({
      value: option.value,
      label: this.$t(option.label),
    }));
  }

  get placeholder() {
    return this.$t('searchList');
  }

  inputSearchOption(value: any) {
    this.searchOption = value.value || '';
  }

  getStatusColor(status: string): string {
    const statusColors: Record<string, string> = {
      OPEN: '#4492DB',
      DELETED: '#6C6C6C',
      CANCELED: '#B20106',
      DONE: '#3FAF28',
    };
    return statusColors[status] || '#000000';
  }

  removeWorkItem(workItem: WorkItemSummary): void {
    this.selectedWorkItens = this.selectedWorkItens.filter(item => item.id !== workItem.id);
    this.$emit('remove-work-item', workItem);
  }

  clearAll(): void {
    this.selectedWorkItens = [];
    this.$emit('clear-all');
  }

  async reprocess() {
    this.reprocessing = true;
    const idList = this.selectedWorkItens.map((item: WorkItemSummary) => item.id);
    try {
      await this.deleteErrors(this.project.id, idList);
      await WorkItemService.reprocessingWorkItems(idList);
      snackBarService.successMessage('workItemReprocessed');
    } catch (error) {
      console.error('Error during reprocessing:', error);
    } finally {
      this.clearAll();
      this.reprocessing = false;
      this.$emit('cancel');
    }
  }

  async deleteErrors(project: string, idList: string[]): Promise<void> {
    await WorkItemService.deleteWorkItemsError(project, idList);
  }

  get filteredWorkItens() {
    if (!this.searchInput) {
      return this.selectedWorkItens;
    }
    const search = this.searchInput.toLowerCase();
    if (this.searchOption === 'number') {
      return this.selectedWorkItens.filter(item => item.workItemNumber
        && String(item.workItemNumber) === search);
    }
    return this.selectedWorkItens.filter(item => item.title
      && item.title.toLowerCase().includes(search));
  }

  clearSearch() {
    this.searchInput = '';
    this.searchOption = '';
  }
}
